import { AddonsContext } from '@context/Addons';
import { useContext } from 'react';

export default function useAddonsContext() {
  return useContext(AddonsContext);
}
